import React from "react";
import { LoadingIndicator } from "react-admin";
// import { withRouter } from "react-router";
// import {Blob} from 'node:buffer';

import {
    useParams
} from "react-router-dom";
import { baseURL, httpClient } from "../providers/constants";


function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class DownloadReport extends React.Component {
    componentDidMount() {
        let { type, id, name } = this.props.params;
        var report_url = '/generate-reimbursable-report';
        if (type === 'remuneration') {
            report_url = '/generate-report'
        }
        fetch(baseURL + report_url + '?id=' + id,
            {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': localStorage.getItem('access_token') },
            }).then(response => response.blob()).then(blob => {
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    name + '.xlsx',
                );

                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                link.parentNode.removeChild(link);
                window.open("about:blank", "_self");
                // window.close();
            })
    }

    render() {
        return (
            <div><p><h5>                Your download will start in a bit, please wait!</h5></p></div>
        );
    }
}

export default withParams(DownloadReport);